import React from 'react'
import { dailyOpsContent } from "../../SopsData.js"
import TabView from '../../../../components/prime-react-overrides/tab-view/TabView'

function DailyOperations() {


    return (

        <div> 

            <div className="flex w-full justify-content-center  align-content-center">
                <span className="text-xl font-bold mb-2">Daily operations</span>
            </div>
            <TabView data={dailyOpsContent} >
            </TabView>


        </div>
    )

}




export default DailyOperations